import * as React from "react";
import { useState } from "react";
import { Genome } from "../../api";
import { getQCValue } from "../../utils/genomes";
import { QualityControlSection } from "../quality-control";
import { ReplicateGroup, ReplicateHeader, ReplicateItem } from "../replicate";
import { SelectLotNumber } from "../select-lot-number";

const RNASeqQCSection = ({ genome }: { genome: Genome }) => {
  const [lotNumberIndex, setLotNumberIndex] = useState<number>(0);

  const rnaSeq = genome.attributes.atcc_metadata?.rna_sequencing;
  if (!rnaSeq) {
    return null;
  }
  const lotNumbers = Object.keys(rnaSeq.lot_number);
  if (lotNumbers.length === 0) {
    return null;
  }

  const lotNum = lotNumbers[lotNumberIndex];
  const qc = rnaSeq.lot_number[lotNum]!.qc_statistics;
  const n = qc.sample_summary.replicate_count;

  const headers: ReplicateHeader[] = [
    { label: "Library Kit", isNumber: false },
    { label: "Reference", isNumber: false },
    { label: "Nanodrop A260/280", isNumber: true },
    { label: "Tapestation RIN", isNumber: true, fractionDigits: 1 },
    { label: "Total Input Reads", isNumber: true },
    { label: "Uniquely Mapped Reads (%)", isNumber: true },
  ];

  const items: ReplicateItem[] = [];

  for (let i = 0; i < n; ++i) {
    items.push({
      name: (
        <>
          Replicate <em>#{i + 1}</em>
        </>
      ),
      runDate: qc.illumina_metadata.run_date[i] ?? "",
      sampleName: qc.sample_summary.sample_name[i],
      values: [
        qc.illumina_metadata.library_kit,
        getQCValue(qc.sample_summary.references, i),
        getQCValue(qc.extraction_qc["nanodrop_a260/a280"], i),
        getQCValue(qc.extraction_qc.tapestation_rin, i),
        getQCValue(qc.input_reads_summary.number_of_input_reads, i),
        getQCValue(qc.input_reads_summary.percent_of_reads_uniquely_mapped, i),
      ],
    });
  }

  return (
    <QualityControlSection
      header={"RNA Extraction and Sequencing Quality Control"}
      right={
        lotNumbers.length > 1 ? (
          <SelectLotNumber
            value={lotNumberIndex}
            lotNumbers={lotNumbers}
            onChange={setLotNumberIndex}
          />
        ) : undefined
      }
    >
      <ReplicateGroup
        data={{ headers: headers, items: items }}
        explanation={
          <>
            Biological replicates were grown in accordance with the item’s Product Sheet located on
            the individual product pages.
          </>
        }
      />
    </QualityControlSection>
  );
};

export default RNASeqQCSection;
